import { render, staticRenderFns } from "./atcd-historique-allergologie-environnement-vie.html?vue&type=template&id=26631d59&scoped=true&external"
import script from "./atcd-historique-allergologie-environnement-vie.js?vue&type=script&lang=js&external"
export * from "./atcd-historique-allergologie-environnement-vie.js?vue&type=script&lang=js&external"
import style0 from "./atcd-historique-allergologie-environnement-vie.scss?vue&type=style&index=0&id=26631d59&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26631d59",
  null
  
)

export default component.exports